import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { Dayjs } from "dayjs";

class UpdateSelectedChangeDateAction extends BaseAction<void, [Dayjs | null, Dayjs | null]> {

    override async run(): Promise<void> {
        updateRecoilState("selectedChangeDateAtom", this.params);
    }
}

export const updateSelectedChangeDateAction = new UpdateSelectedChangeDateAction()


